import {
  Container,
  Box,
  Checkbox,
  FormControlLabel,
  Typography,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import {
    Fragment
} from "react";

const FormRequirePDF = ({
    reqData,
    User0
}) => {
    if (!reqData) return null;
  return (
    <div>
       <Container>
        <Box>
            <Typography variant="h6">メッセナゴヤ出展者　マイページ情報</Typography>
            {reqData ? (
            <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
                <Typography variant="body1">小間番号: {reqData?.booth_number}</Typography>
                <Typography variant="body1">出展者名: {reqData?.company_name}</Typography>
                <Typography variant="body1">部署: {reqData?.department}</Typography>
                <Typography variant="body1">担当者名: {reqData?.user_name}</Typography>
                <Typography variant="body1">郵便番号: {reqData?.zip_code}</Typography>
                <Typography variant="body1">住所: {reqData?.address}</Typography>
                <Typography variant="body1">電話番号: {reqData?.phone_number}</Typography>
                <Typography variant="body1">メールアドレス: {reqData?.email}</Typography>
            </Box>
            ) : (
            <Typography variant="body2">読み込み中...</Typography>
            )}
        </Box>
        <Container sx={{mt:4}}>
            <Typography variant="h6" sx={{ backgroundColor: '#fff', px: 1, width: '95%', margin: 'auto'}}>出展責任者登録</Typography>
            <Box sx={{ p: 2 }}>
                <Typography variant="h6" gutterBottom>責任者情報</Typography>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "120px 1fr 120px 1fr",
                    gap: "4px 12px",
                    fontSize: "12px",
                    lineHeight: 1.4,
                    whiteSpace: "nowrap",
                  }}
                >
                    <Box>氏名</Box>
                    <Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.manager_name}</Box>

                    <Box>部署</Box>
                    <Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.manager_department}</Box>

                    <Box>会社TEL</Box>
                    <Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.manager_phone}</Box>

                    <Box>携帯TEL</Box>
                    <Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.manager_tel}</Box>
                </Box>

                <Typography variant="h6" sx={{ mt: 4 }}>担当者情報</Typography>
                <FormControl component="fieldset" sx={{ mt: 2 }}>
                    <FormLabel component="legend">出展申込時の担当者と</FormLabel>
                    <RadioGroup
                    row
                    value={reqData?.r1.same_ex_1}
                    >
                    <FormControlLabel value="same" control={<Radio />} label="同じ" />
                    <FormControlLabel value="different" control={<Radio />} label="異なる" />
                    </RadioGroup>
                </FormControl>
                <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: "120px 1fr 120px 1fr",
                    gap: "4px 12px",
                    fontSize: "12px",
                    lineHeight: 1.4,
                    whiteSpace: "nowrap",
                }}
                >
                    <Box>氏名</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.user_1_name}</Box>
                    <Box>部署</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.user_1_department}</Box>
                    <Box>会社電話番号</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.user_1_phone}</Box>
                    <Box>携帯電話番号</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.user_1_tel}</Box>
                </Box>
                

                <Box>
                    <Box>
                    <FormControlLabel
                    control={<Checkbox checked={reqData?.r1.pledge} sx={{color: 'red'}} />}
                    label="出展規定及び出展の手引きを遵守し、出展することを誓約します。"
                    />
                    
                </Box>
                <Box>
                    {User0 && (
                    <>
                    <FormControlLabel
                        control={
                        <Checkbox
                            checked={reqData?.r1.panel_pledge}
                            sx={{ color: 'red' }}
                        />
                        }
                        label="システムパネル・突出し社名板を追加希望する。"
                    />
                    {reqData?.r1.panel_pledge && (
                    <>
                    <Typography
                        fullWidth
                        multiline
                        rows={4}
                        label="突出し社名板用質問欄"
                        value={reqData?.r1.panel_question}
                    />
                    </>
                    )}
                    <Box>
                        <FormControl component="fieldset" fullWidth sx={{ mt: 2 }}>
                        <FormLabel component="legend">社名板の表記方法</FormLabel>
                        
                        <RadioGroup
                            name="panel_plan"
                            value={reqData?.r1.panel_plan || ""}
                        >
                            <FormControlLabel
                            value="親出展者名のみ表記"
                            control={<Radio />}
                            label="親出展者名のみ表記"
                            />
                            <Box sx={{ mt: 1 }}>
                                <img src="/parent_only.png" alt="親出展者名のみ表記" width="250px" />
                            </Box>
                            <FormControlLabel
                            value="子出展者名メインで表記"
                            control={<Radio />}
                            label="子出展者名メインで表記"
                            />
                            <Box sx={{ mt: 1 }}>
                                <img src="/child_only.png" alt="子出展者名メインで表記" width="250px" />
                            </Box>
                            <FormControlLabel
                            value="親・子出展者名を並列で表記"
                            control={<Radio />}
                            label="親・子出展者名を並列で表記"
                            />
                            <Box sx={{ mt: 1 }}>
                                <img src="/parallel.png" alt="親・子出展者名を並列で表記" width="250px" />
                            </Box>
                            <FormControlLabel
                            value="グループ表記"
                            control={<Radio />}
                            label="グループ表記"
                            />
                            <Box sx={{ mt: 1 }}>
                                <img src="/group.png" alt="グループ表記" width="250px" />
                            </Box>
                        </RadioGroup>
                        </FormControl>
                    </Box>
                    </>
                    )}
                </Box>

                <Typography variant="h6" gutterBottom>委託会社情報</Typography>
                
                <FormControlLabel
                    control={
                    <Checkbox
                        checked={reqData?.r1.has_package_company}
                    />
                    }
                    label="装飾委託会社あり"
                />

                {reqData?.r1.has_package_company && (
                    <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: "120px 1fr 120px 1fr",
                        gap: "4px 12px",
                        fontSize: "12px",
                        lineHeight: 1.4,
                        whiteSpace: "nowrap",
                    }}
                    >
                        <Box>会社名</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.package_company_name || ""}</Box>
                        <Box>会社電話番号</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.package_company_tel || ""}</Box>
                        <Box>携帯電話番号</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.package_phone_number || ""}</Box>
                        <Box>郵便番号</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.package_company_zip || ""}</Box>
                        <Box>住所</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.package_company_address || ""}</Box>
                        <Box>FAX番号</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.package_company_fax || ""}</Box>
                        <Box>担当者名</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.package_name || ""}</Box>
                    </Box>
                )}
                {/* 以下、elec / infla / cargo もパッケージ会社と同じフォーマットで */}
                <FormControlLabel
                    control={
                    <Checkbox
                        checked={reqData?.r1.has_elec_company}
                    />
                    }
                    label="電気工事委託会社あり"
                />

                {reqData?.r1.has_elec_company && (
                    <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: "120px 1fr 120px 1fr",
                        gap: "4px 12px",
                        fontSize: "12px",
                        lineHeight: 1.4,
                        whiteSpace: "nowrap",
                    }}
                    >
                        <Box>会社名</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.elec_company_name || ""}</Box>
                        <Box>会社電話番号</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.elec_company_tel || ""}</Box>
                        <Box>携帯電話番号</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.elec_phone_number || ""}</Box>
                        <Box>郵便番号</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.elec_company_zip || ""}</Box>
                        <Box>住所</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.elec_company_address || ""}</Box>
                        <Box>FAX番号</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.elec_company_fax || ""}</Box>
                        <Box>担当者名</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.elec_name || ""}</Box>
                    </Box>
                )}

                {/* infla、cargo も同様にここに並べていく */}
                <FormControlLabel
                    control={
                    <Checkbox
                        checked={reqData?.r1.has_infla_company}
                    />
                    }
                    label="給排水・エア・ガス工事委託会社あり"
                />

                {reqData?.r1.has_infla_company && (
                    <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: "120px 1fr 120px 1fr",
                        gap: "4px 12px",
                        fontSize: "12px",
                        lineHeight: 1.4,
                        whiteSpace: "nowrap",
                    }}
                    >
                        <Box>会社名</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.infla_company_name || ""}</Box>
                        <Box>会社電話番号</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.infla_company_tel || ""}</Box>
                        <Box>携帯電話番号</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.infla_phone_number || ""}</Box>
                        <Box>郵便番号</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.infla_company_zip || ""}</Box>
                        <Box>住所</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.infla_company_address || ""}</Box>
                        <Box>FAX番号</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.infla_company_fax || ""}</Box>
                        <Box>担当者名</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.infla_name || ""}</Box>
                    </Box>
                )}
                <FormControlLabel
                    control={
                    <Checkbox
                        checked={reqData?.r1.has_cargo_company}
                    />
                    }
                    label="荷役委託会社あり"
                />

                {reqData?.r1.has_cargo_company && (
                    <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: "120px 1fr 120px 1fr",
                        gap: "4px 12px",
                        fontSize: "12px",
                        lineHeight: 1.4,
                        whiteSpace: "nowrap",
                    }}
                    >
                        <Box>会社名</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.cargo_company_name || ""}</Box>
                        <Box>会社電話番号</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.cargo_company_tel || ""}</Box>
                        <Box>携帯電話番号</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.cargo_phone_number || ""}</Box>
                        <Box>郵便番号</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.cargo_company_zip || ""}</Box>
                        <Box>住所</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.cargo_company_address || ""}</Box>
                        <Box>FAX番号</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.cargo_company_fax || ""}</Box>
                        <Box>担当者名</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r1.cargo_name || ""}</Box>
                    </Box>
                )}

                <Typography variant="h6" sx={{ mt: 4 }}>備考欄</Typography>
                
                <Typography sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                {reqData?.r1?.alfa_text}
                </Typography>
                </Box>
            </Box>

            {/* Comp2 */}
            <Typography variant="h6" sx={{ backgroundColor: '#fff', px: 1, width: '95%', mx: 'auto', my: 4}}>搬入・搬出計画登録</Typography>
            <Box>
                <Typography variant="h6" gutterBottom>担当者情報</Typography>
                
                <FormControl component="fieldset" sx={{ mt: 2 }}>
                    <FormLabel component="legend">出展申込時の担当者と</FormLabel>
                    <RadioGroup
                    row
                    value={reqData?.r2.same_ex_2}
                    >
                    <FormControlLabel value="same" control={<Radio />} label="同じ" />
                    <FormControlLabel value="different" control={<Radio />} label="異なる" />
                    </RadioGroup>
                </FormControl>
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: "120px 1fr 120px 1fr",
                        gap: "4px 12px",
                        fontSize: "12px",
                        lineHeight: 1.4,
                        whiteSpace: "nowrap",
                    }}
                >
                    <Box>氏名</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r2.user_2_name}</Box>
                    <Box>部署</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r2.user_2_department}</Box>
                    <Box>会社電話番号</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r2.user_2_phone}</Box>
                    <Box>携帯電話番号</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{reqData?.r2.user_2_tel}</Box>
                </Box>
                

                <Typography variant="h6" sx={{ mt: 4 }}>搬入・搬出方法</Typography>
                <Box>
                    {/* 方法選択（ラジオ） */}
                    <FormControl fullWidth>
                    <RadioGroup
                        name="method"
                        value={
                            reqData?.r2.method?.startsWith("その他｜")
                            ? "その他"
                            : reqData?.r2.method
                        }
                    >
                        <FormControlLabel
                        value="運送会社活用パターン"
                        control={<Radio />}
                        label="運送会社活用パターン"
                        />
                        <FormControlLabel
                        value="周辺駐車場活用パターン"
                        control={<Radio />}
                        label="周辺駐車場活用パターン"
                        />
                        <FormControlLabel
                        value="展示館内及び展示館ローディングヤードへの乗り入れが必要なパターン"
                        control={<Radio />}
                        label="展示館内及び展示館ローディングヤードへの乗り入れが必要なパターン"
                        />
                        <FormControlLabel value="その他" control={<Radio />} label="その他" />
                    </RadioGroup>
                    {reqData?.r2?.method?.startsWith('その他｜') && (
                    <Typography>その他内容 : {reqData?.r2?.method}</Typography>
                    )}
                    </FormControl>

                    {/* 搬入希望日選択（ラジオ） */}
                    <FormControl>
                    <Typography variant='h6'>搬入予定日</Typography>
                    <RadioGroup
                        name="reserve_date"
                        value={reqData?.r2?.reserve_date}
                        row
                    >
                        <FormControlLabel value="11/9" control={<Radio />} label="11月9日（月）" />
                        <FormControlLabel value="11/10" control={<Radio />} label="11月10日（火）" />
                        <FormControlLabel value="other" control={<Radio />} label="その他" />
                    </RadioGroup>
                    {reqData?.r2.reserve_date === "other" && (
                        <Typography>その他詳細 ： {reqData?.r2?.reserve_detail}</Typography>
                    )}
                    </FormControl>
                </Box>

                <Box>
                    <FormControl>
                        <Typography variant="h6" sx={{ mt: 4 }}>展示館内への車両乗り入れ</Typography>
                        <RadioGroup row name="indoor_car" value={reqData?.r2?.indoor_car ? 'true' : 'false'}>
                        <FormControlLabel value="true" control={<Radio />} label="する" />
                        <FormControlLabel value="false" control={<Radio />} label="しない" />
                        </RadioGroup>
                    </FormControl>
                </Box>

                <Box>
                {reqData?.r2.indoor_car && (
                    <>
                    {[
                        { label: "小型車（2tクラス以下）", name: "mini_num" },
                        { label: "中型車（4tクラス以下）", name: "norm_num" },
                        { label: "大型車（10tクラス以下）", name: "big_num" },
                        { label: "トレーラー（コンテナを含む）", name: "trail_num" },
                        { label: "クレーン", name: "crain_num" },
                        { label: "フォークリフト", name: "fork_num" },
                        { label: "その他台数", name: "other_num" },
                    ].map(({ label, name }) => (
                        <Fragment key={name}>
                            <Box sx={{ display: "flex", justifyContent: "flex-start", gap: 2, alignItems: "center" }}>
                                <Box>{label}</Box>
                                <Box sx={{ textAlign: "right" }}>
                                    {reqData?.r2[name] ?? "-"}
                                </Box>
                            </Box>
                        </Fragment>
                    ))}

                    {/* 「その他台数」に値があるときだけ詳細入力を表示 */}
                    {reqData?.r2.other_num && String(reqData?.r2.other_num).trim() !== "" && Number(reqData?.r2.other_num) > 0 && (    
                        <Typography
                            fullWidth
                            label="車両・重機の概要"
                            name="other_detail"
                            value={reqData?.r2.other_detail || ""}
                        />
                    )}
                    </>
                )}
                </Box>
                
                {reqData?.r2.indoor_car && (
                    <>
                    <Typography variant="h6" sx={{ mt: 4 }}>出展物の詳細</Typography>
                    {reqData?.r2?.details?.map((detail, index) => (
                        <Box
                          key={index}
                          sx={{
                            display: "grid",
                            gridTemplateColumns: "120px 1fr 120px 1fr",
                            gap: "4px 12px",
                            fontSize: "12px",
                            lineHeight: 1.4,
                            whiteSpace: "nowrap",
                            pb: 2
                          }}
                        >
                            <Box>展示物名</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{detail.exhibition}</Box>
                            <Box>個数</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{detail.number}</Box>
                            <Box>重量(kg)</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{detail.weight}</Box>
                            <Box>長(mm)</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{detail.length}</Box>
                            <Box>幅(mm)</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{detail.width}</Box>
                            <Box>高(mm)</Box><Box sx={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    borderRight: "1px solid #999",
  }}>{detail.height}</Box>
                        </Box>
                    ))}
                    </>
                )}

                <Typography variant="h6" sx={{ mt: 4 }}>備考欄</Typography>
                
                <Typography sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                {reqData?.r2?.alfa_text}
                </Typography>
            </Box>
        </Container>
      </Container>
    </div>
  );
};

export default FormRequirePDF;
